import { React, useState, useEffect, useRef, useContext } from "react";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../../AppStore';
import GridNoRow from '../../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PurchaseSelectModal from "../../../../modal/PC/common/PurchaseSelectModal";
import IncomingSelectModal from "../../../../modal/PC/common/IncomingSelectModal";
import PartnerUserSelectModal from "../../../../modal/PC/common/PartnerUserSelectModal";
import ItemSelectModal from "../../../../modal/PC/common/ItemSelectModal";
import UserSelectModal from "../../../../modal/PC/common/UserSelectModal";
import WorkplaceSelectModal from "../../../../modal/PC/common/WorkplaceSelectModal";
import WarehouseSelectModal from "../../../../modal/PC/common/WarehouseSelectModal";
import WarehouseSectionSelectModal from "../../../../modal/PC/common/WarehouseSectionSelectModal";
import Moment from 'moment';
import "moment/locale/ko";

let newFileID = 1;
let realFiles = [];
let tmpRealFiles = [];

function TAB_IncomingReg({ title, onClose, handleRegSuccessSave, userTypeModalOption, qualityYnModalOption, MenuUpdateYN, payload}) {
  const appStore = useContext(AppContext);
  const apiRef = useGridApiRef();
  const tabPanelRef = useRef();
  const [tabPanelHeight, setTabPanelHeight] = useState(0);
  const [itemRows, setItemRows] = useState([]);
  const [updateItemRows, setUpdateItemRows] = useState([]);
  const [itemColumns, setItemColumns] = useState([]);
  const [lotRows, setLotRows] = useState([]);
  const [updateLotRows, setUpdateLotRows] = useState([]);
  const [lotColumns, setLotColumns] = useState([]);
  const [userRows, setUserRows] = useState([]);
  const [updateUserRows, setUpdateUserRows] = useState([]);
  const [userColumns, setUserColumns] = useState([]);
  const [fileRows, setFileRows] = useState([]);
  const [updateFileRows, setUpdateFileRows] = useState([]);
  const [fileColumns, setFileColumns] = useState([]);
  const [tabID, setTabID] = useState('1');
  const [inputs, setInputs] = useState({
    incoming_id: null,
    incoming_number: '',
    incoming_purchase_number: '',
    incoming_date: appStore.YYYY_MM_DD(),
    incoming_partner_id: 0,
    incoming_partner_name: '',
    incoming_partner_manager: '',
    incoming_partner_manager_phone: '',
    incoming_partner_manager_mail: '',
    incoming_bigo: '',
    incoming_purchase_id: null,
    incoming_ref_incoming_id:null
  });
  const [lotNoStartNumber, setLotNoStartNumber] = useState('1');
  const [selectmodalTitle, setSelectModalTitle] = useState('');
  const [isSelectPurchaseModalOpen, setSelectPurchaseModalOpen] = useState(false);
  const [isSelectIncomingModalOpen, setSelectIncomingModalOpen] = useState(false);
  const [isSelectPartnerModalOpen, setSelectPartnerModalOpen] = useState(false);
  const [isSelectItemModalOpen, setSelectItemModalOpen] = useState(false);
  const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
  const [isSelectWorkplaceModalOpen, setSelectWorkplaceModalOpen] = useState(false);
  const [isSelectWarehouseModalOpen, setSelectWarehouseModalOpen] = useState(false);
  const [isSelectWarehouseSectionModalOpen, setSelectWarehouseSectionModalOpen] = useState(false);
  const [selectItemData, setSelectItemData] = useState('');
  const [selectUserData, setSelectUserData] = useState('');
  const [selectLotData, setSelectLotData] = useState('');
  const [selectModalType, setSelectModalType] = useState('');
  const [upperWorkplaceId, setUpperWorkplaceId] = useState(0);
  const [upperWarehouseId, setUpperWarehouseId] = useState(0);

  const handleSetting = () => {
    setItemColumns([
      (MenuUpdateYN === "Y"?
        {
            field: 'actions',
            headerName: '동작',
            width: 55,
            type:'actions',
            disableClickEventBubbling: true,
            getActions: (params) => [
                ((params.row.update_type === "U")? 
                <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
                : (params.row.row_type === "A" && params.row.update_type === "N")? 
                <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {itemAddClick(params)}} label="Add"  /> 
                :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {itemDeleteClick(params)}} label="Delete" />
                )
              ],
            headerAlign: 'center', 
            align:'center'
        } : {}),
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'incoming_item_id', headerName: 'incoming_item_id', headerAlign: 'center', align:'center' },
      { field: 'incoming_item_name', headerName: '품목', flex: 1, minWidth: 120, headerAlign: 'center', align:'left' },
      { field: 'incoming_item_spec', headerName: '규격', width: 120, headerAlign: 'center', align:'left' },
      { field: 'incoming_package_count', headerName: '수량', type: 'number', width: 80, headerAlign: 'center', align:'right', editable: true },
      { field: 'incoming_pack_rate', headerName: '포장수량', type: 'number', width: 70, headerAlign: 'center', align:'right', editable: true },
      { field: 'incoming_item_count', headerName: '입고수량', type: 'number', width: 100, headerAlign: 'center', align:'right', editable: false },
      { field: 'incoming_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'incoming_save_workplace_id', headerName: 'incoming_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'incoming_save_workplace_name', headerName: '사업장',width: 90, headerAlign: 'center'},
      { field: 'incoming_save_warehouse_id', headerName: 'incoming_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'incoming_save_warehouse_name', headerName: '창고', width: 90, headerAlign: 'center', align:'left' },
      { field: 'incoming_save_section_id', headerName: 'incoming_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'incoming_save_section_name', headerName: '구역',width: 90, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setLotColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'upper_id', headerName: 'upper_id', width: 0, headerAlign: 'center' },
      { field: 'lot_no', headerName: 'LotNo', width: 165, headerAlign: 'center', align:'center' },
      { field: 'lot_incoming_item_id', headerName: 'lot_incoming_item_id', headerAlign: 'center', align:'center' },
      { field: 'lot_incoming_item_name', headerName: '품목', width: 150, headerAlign: 'center', align:'left' },
      { field: 'lot_incoming_item_spec', headerName: '규격', width: 165, headerAlign: 'center', align:'left' },
      { field: 'lot_incoming_quality_exam_yn', headerName: '검사여부', type: 'singleSelect', width: 80, 
        valueOptions: () => qualityYnModalOption ?? [], valueFormmatter: ({  value }) => 
          qualityYnModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'lot_incoming_save_workplace_id', headerName: 'lot_incoming_save_workplace_id',width: 0, headerAlign: 'center'},
      { field: 'lot_incoming_save_workplace_name', headerName: '사업장',width: 110, headerAlign: 'center'},
      { field: 'lot_incoming_save_warehouse_id', headerName: 'lot_incoming_save_warehouse_id', width: 0, headerAlign: 'center' },
      { field: 'lot_incoming_save_warehouse_name', headerName: '창고', width: 110, headerAlign: 'center', align:'left' },
      { field: 'lot_incoming_save_section_id', headerName: 'lot_incoming_save_section_id',width: 0, headerAlign: 'center'},
      { field: 'lot_incoming_save_section_name', headerName: '구역',width: 110, headerAlign: 'center', align:'left'},
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setUserColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'incoming_user_id', headerName: 'incoming_user_id', width: 0, headerAlign: 'center' },
      { field: 'incoming_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'incoming_user_dept_name', headerName: '담당자부서', width: 120, headerAlign: 'center', align:'center' },
      { field: 'incoming_user_position_name', headerName: '담당자직위', width: 120, headerAlign: 'center', align:'center' },
      { field: 'incoming_user_type', headerName: '담당자유형', type: 'singleSelect', width: 120, 
        valueOptions: () => userTypeModalOption ?? [], valueFormmatter: ({  value }) => 
        userTypeModalOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
        editable: true, headerAlign: 'center', align:'center' },
      { field: 'incoming_user_bigo', headerName: '비고', width: 350, headerAlign: 'center', align:'left', editable: true },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setFileColumns([
      {
        field: 'actions',
        headerName: '동작',
        width: 55,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.update_type === "U")? 
            <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            : (params.row.row_type === "A" && params.row.update_type === "N")? 
            <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {fileAddClick(params)}} label="Add"  /> 
            :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {fileDeleteClick(params)}} label="Delete" />
            )
          ],
        headerAlign: 'center', 
        align:'center'
      },
      {
        field: 'download',
        headerName: '다운로드',
        width: 90,
        type:'actions',
        disableClickEventBubbling: true,
        getActions: (params) => [
            ((params.row.row_type === "O")?
            <GridActionsCellItem icon={<DownloadIcon color={ "primary" } />} onClick={() => {fileDownloadClick(params)}} label="Download" />:<></>)
        ],
        headerAlign: 'center', 
        align:'center'
      },
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
      { field: 'file_name_sever', headerName: 'file_name_sever', width: 0, headerAlign: 'center' },
      { field: 'file_size', headerName: 'file_size', width: 0, headerAlign: 'center' },
      { field: 'file_type', headerName: 'file_type', width: 0, headerAlign: 'center' },
      { field: 'file_extension', headerName: 'file_extension', width: 0, headerAlign: 'center' },
      { field: 'file_name', headerName: '파일명', width: 270, headerAlign: 'center' },
      { field: 'file_type_name', headerName: '유형', width: 110, headerAlign: 'center', align:'center' },
      { field: 'file_size_dp', headerName: '크기', width: 100, headerAlign: 'center', align:'right' },
      { field: 'reg_user_name', headerName: '등록자', width: 90, headerAlign: 'center', align:'center' },
      { field: 'reg_datetime', headerName: '등록일시', width: 160, headerAlign: 'center', align:'center' },
      { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
      { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
    ]);

    setItemColumnVisibilityModel({
      id: false,
      actions: true,
      incoming_item_id: false,
      incoming_item_name: true,
      incoming_item_spec: false,
      incoming_package_count: true,
      incoming_pack_rate: true,
      incoming_item_count: true,
      incoming_quality_exam_yn: false,
      incoming_save_workplace_id: false,
      incoming_save_workplace_name: true,
      incoming_save_warehouse_id: false,
      incoming_save_warehouse_name: true,
      incoming_save_section_id: false,
      incoming_save_section_name: true,
      row_type: false,
      update_type: false
    });

    setLotColumnVisibilityModel({
      id: false,
      upper_id: false,
      lot_no: true,
      lot_incoming_item_id: false,
      lot_incoming_item_name: true,
      lot_incoming_item_spec: false,
      lot_incoming_quality_exam_yn: false,
      lot_incoming_save_workplace_id: false,
      lot_incoming_save_workplace_name: true,
      lot_incoming_save_warehouse_id: false,
      lot_incoming_save_warehouse_name: true,
      lot_incoming_save_section_id: false,
      lot_incoming_save_section_name: true,
      row_type: false,
      update_type: false
    });

    setUserColumnVisibilityModel({
      id: false,
      actions: true,
      incoming_user_id: false,
      incoming_user_name: true,
      incoming_user_dept_name: true,
      incoming_user_position_name: true,
      incoming_user_type: true,
      incoming_user_bigo: true,
      row_type: false,
      update_type: false
    });

    setFileColumnVisibilityModel({
      id: false,
      file_name_sever: false,
      file_size: false,
      file_type: false,
      file_extension: false,
      file_name: true,
      file_type_name: true,
      file_size_dp: true,
      reg_user_name: true,
      reg_datetime: true,
      actions: true,
      download: true,
      row_type: false,
      update_type: false
    });
  }

  const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    incoming_item_id: false,
    incoming_item_name: true,
    incoming_item_spec: false,
    incoming_package_count: true,
    incoming_pack_rate: true,
    incoming_item_count: true,
    incoming_quality_exam_yn: true,
    incoming_save_workplace_id: false,
    incoming_save_workplace_name: true,
    incoming_save_warehouse_id: false,
    incoming_save_warehouse_name: true,
    incoming_save_section_id: false,
    incoming_save_section_name: true,
    row_type: false,
    update_type: false
  });

  const [lotColumnVisibilityModel, setLotColumnVisibilityModel] = useState({
    id: false,
    upper_id: false,
    lot_no: true,
    lot_incoming_item_id: false,
    lot_incoming_item_name: true,
    lot_incoming_item_spec: false,
    lot_incoming_quality_exam_yn: true,
    lot_incoming_save_workplace_id: false,
    lot_incoming_save_workplace_name: true,
    lot_incoming_save_warehouse_id: false,
    lot_incoming_save_warehouse_name: true,
    lot_incoming_save_section_id: false,
    lot_incoming_save_section_name: true,
    row_type: false,
    update_type: false
  });

  const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
    id: false,
    actions: true,
    incoming_user_id: false,
    incoming_user_name: true,
    incoming_user_dept_name: true,
    incoming_user_position_name: true,
    incoming_user_type: true,
    incoming_user_bigo: true,
    row_type: false,
    update_type: false
  });

  const [fileColumnVisibilityModel, setFileColumnVisibilityModel] = useState({
    id: false,
    file_name_sever: false,
    file_size: false,
    file_type: false,
    file_extension: false,
    file_name: true,
    file_type_name: true,
    file_size_dp: true,
    reg_user_name: true,
    reg_datetime: true,
    actions: true,
    download: true,
    row_type: false,
    update_type: false
  });

  useEffect(() => {
    if (payload && (payload.from === 'excel_upload' || payload.from === 'excel_dragdrop') && payload.uploadResult) {
      const data = payload.uploadResult;

      setInputs(prev => ({
        ...prev,
        incoming_date: data.order_date || appStore.YYYY_MM_DD(),
        incoming_partner_id: Number(data.partner_id) || 0,
        incoming_partner_name: data.partner_name || '',
        incoming_partner_manager: data.partner_manager || '',
        incoming_partner_manager_phone: data.partner_manager_phone || '',
        incoming_partner_manager_email: data.partner_manager_mail || '', 
        incoming_bigo: data.remark || '',
      }));

      if (data.items && data.items.length > 0) {
        const validItems = data.items.filter(it => it.item_id || it.item_name);
        
        const processIncomingItems = async () => {
          const parsedItems = validItems.map((it, idx) => ({
            id: idx + 1,
            incoming_item_id: it.item_id || '',
            incoming_item_name: it.item_name || '',
            incoming_item_spec: it.item_spec || '',
            incoming_package_count: Number(it.qty) || 0,
            incoming_pack_rate: 1, 
            incoming_item_count: (Number(it.qty) || 0) * 1,
            incoming_quality_exam_yn: 'N',
            incoming_save_workplace_id: it.wp_id ? Number(it.wp_id) : null,
            incoming_save_workplace_name: it.wp_name || '',
            incoming_save_warehouse_id: it.wh_id ? Number(it.wh_id) : null,
            incoming_save_warehouse_name: it.wh_name || '',
            incoming_save_section_id: it.sec_id ? Number(it.sec_id) : null,
            incoming_save_section_name: it.sec_name || '',
            row_type: 'A', update_type: 'U'
          }));

          setItemRows(parsedItems);
          setUpdateItemRows(parsedItems);

          const targetDate = data.order_date || appStore.YYYY_MM_DD();
          try {
            const res = await axios.get('/api/Common/LotNoStartNumber', {
              params: { type: 'I', date: targetDate }
            });
            createLotRow(parsedItems, {}, 'A', targetDate, res.data);
          } catch (e) {
            createLotRow(parsedItems, {}, 'A', targetDate, '1');
          }
        };
        processIncomingItems();
      }

      if (data.users && data.users.length > 0) {
        const validUsers = data.users.filter(u => u.user_id || u.user_name);
        const parsedUsers = validUsers.map((u, idx) => ({
          id: idx + 1,
          incoming_user_id: u.user_id || '',
          incoming_user_name: u.user_name || '',
          incoming_user_type: Number(u.user_type_id) || 0,
          incoming_user_dept_name: u.user_dept_name || '',
          incoming_user_position_name: u.user_position_name || '',
          incoming_user_bigo: u.remark || '',
          row_type: 'A',
          update_type: 'U'
        }));
        setUserRows(parsedUsers);
        setUpdateUserRows(parsedUsers);
      }
    }
  }, [payload]);

  useEffect(() => {
    realFiles = [];
    tmpRealFiles = [];
    handleSetting();
    setTabPanelHeight(tabPanelRef.current.clientHeight);
  }, []);

  useEffect(() => {
    if(itemRows.length === 0 || !inputs.incoming_date) return; 

    if (appStore.loading) return;
    appStore.setLoading(true);

    axios.get('/api/Common/LotNoStartNumber',
      {
        params : {
          type: 'I',
          date: inputs.incoming_date
        }
      },
      { withCredentials: true }
    )
    .then((response) => { 
      setLotNoStartNumber(response.data);
      createLotRow(itemRows, {}, 'A', inputs.incoming_date, response.data);
    })
    .catch((error) => {
        console.log(error);
    })
    .finally(() => {
        appStore.setLoading(false); 
    });
  }, [inputs.incoming_date]);

  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<itemRows.length; i++){
      if(itemRows[i].row_type === 'A' && itemRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        incoming_item_id: '',
        incoming_item_name: '',
        incoming_item_spec: '',
        incoming_package_count: '',
        incoming_pack_rate: '',
        incoming_item_count: '',
        incoming_quality_exam_yn: 'N',
        incoming_save_workplace_id: null,
        incoming_save_workplace_name: '',
        incoming_save_warehouse_id: null,
        incoming_save_warehouse_name: '',
        incoming_save_section_id: null,
        incoming_save_section_name: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [itemRows]);
  
  useEffect(() => {
    let ADD_YN= 'Y'
    for(let i=0; i<userRows.length; i++){
      if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
        ADD_YN = "N"; 
      }
    }

    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        incoming_user_id: '',
        incoming_user_name: '',
        incoming_user_dept_name: '',
        incoming_user_position_name: '',
        incoming_user_type: '',
        incoming_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [userRows]);

  useEffect(() => {
    let ADD_YN= 'Y'
    var array = [];
    for(var i=0; i<fileRows.length; i++){
      var tmp_id = fileRows[i].id;
      var tmp_file_name_sever = fileRows[i].file_name_sever;
      var tmp_file_size = fileRows[i].file_size;
      var tmp_file_type = fileRows[i].file_type;
      var tmp_file_extension = fileRows[i].file_extension;
      var tmp_file_name = fileRows[i].file_name;
      var tmp_file_type_name = fileRows[i].file_type_name;
      var tmp_file_size_dp = fileRows[i].file_size_dp;
      var tmp_reg_user_name = fileRows[i].reg_user_name;
      var tmp_reg_datetime = fileRows[i].reg_datetime;
      var tmp_row_type = fileRows[i].row_type;
      var tmp_update_type = fileRows[i].update_type;
      
      if(tmp_row_type !== 'A' || tmp_update_type !== 'N'){
        array.push({
          id: newFileID,
          file_name_sever: tmp_file_name_sever,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_name: tmp_file_name,
          file_type_name: tmp_file_type_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: tmp_reg_user_name,
          reg_datetime: tmp_reg_datetime,
          row_type:tmp_row_type,
          update_type: tmp_update_type
        })
        newFileID = newFileID + 1;
      }
    }
    setUpdateFileRows(array);
    
    for(let i=0; i<fileRows.length; i++){
      if(fileRows[i].row_type === 'A' && fileRows[i].update_type === 'N'){
        ADD_YN = "N";
      }
    }
    
    if(ADD_YN === 'Y' && MenuUpdateYN==='Y'){
      setFileRows((fileRows) => [...fileRows, { 
        id: Number(appStore.getMaxListID(fileRows))+1,
        file_name_sever: '',
        file_size: 0,
        file_type: '',
        file_extension: '',
        file_name: '',
        file_type_name: '',
        file_size_dp: '',
        reg_user_name: '',
        reg_datetime: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }
  }, [fileRows]);

  const onClick = (e)=>{ 
    setSelectModalTitle('입고처 목록')
    setSelectPartnerModalOpen(true);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const onDateChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
    createLotRow(itemRows, [{id:0}], 'A', e.target.value); 
  };

  const onHypenChange = (e)=>{
    const {name, value} = e.target;
    var hyphen_data = ''
    if(e.target.name === 'incoming_partner_manager_phone'){ // 전화번호인 경우
        hyphen_data = e.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
        .replace(/(-{1,2})$/g, "");
    }
    const nextInputs = {
        ...inputs,
        [name]: hyphen_data, 
    };
    setInputs(nextInputs);
  };

  const handleTabID = (event, newTabID) => {
    setTabID(newTabID);
  };

  const processItemRowUpdate = (newRow, oldRow) => {
    // 입고 품목 Rows Update
    if(newRow.incoming_package_count > 99999 || newRow.incoming_pack_rate > 99999){
      return;
    }

    let newUpdateDataArray = {}
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; 
    
    if(newRow.incoming_item_id !== oldRow.incoming_item_id || newRow.incoming_item_name !== oldRow.incoming_item_name || newRow.incoming_package_count !== oldRow.incoming_package_count || newRow.incoming_pack_rate !== oldRow.incoming_pack_rate || newRow.incoming_quality_exam_yn !== oldRow.incoming_quality_exam_yn || newRow.incoming_save_workplace_id !== oldRow.incoming_save_workplace_id || newRow.incoming_save_warehouse_id !== oldRow.incoming_save_warehouse_id || newRow.incoming_save_section_id !== oldRow.incoming_save_section_id){
      
      // ▼ 수량 혹은 포장이 변경된 경우 총수량 재계산
      if (newRow.incoming_package_count !== oldRow.incoming_package_count || newRow.incoming_pack_rate !== oldRow.incoming_pack_rate){
        const pkgCount = Number(newRow.incoming_package_count || 0);
        const packRate = Number(newRow.incoming_pack_rate || 1);
        newUpdateDataArray = { 
          ...newRow
          , ['incoming_item_count']: pkgCount * packRate
          , update_type: 'U' }; 
      } else {
        newUpdateDataArray = { ...newRow, update_type: 'U' }; 
      }

      var row_incoming_item_id = '';
      var row_incoming_item_name = '';
      var row_incoming_item_spec = '';
      var row_incoming_package_count = '';
      var row_incoming_pack_rate = '';
      var row_incoming_item_count = '';
      var row_incoming_quality_exam_yn = 'N';
      var row_incoming_save_workplace_id = null;
      var row_incoming_save_workplace_name = '';
      var row_incoming_save_warehouse_id = null;
      var row_incoming_save_warehouse_name = '';
      var row_incoming_save_section_id = null;
      var row_incoming_save_section_name = '';

      if(String(newRow.row_type) === "A"){
        if(newRow.incoming_item_id !== '' || newRow.incoming_item_name !== '' || newRow.incoming_item_spec !== '' || newRow.incoming_package_count !== '' || newRow.incoming_pack_rate !== '' || newRow.incoming_quality_exam_yn !== 'N' 
          || newRow.incoming_save_workplace_id !== null || newRow.incoming_save_warehouse_id !== null || newRow.incoming_save_section_id !== null){
          row_incoming_item_id = newRow.incoming_item_id;
          row_incoming_item_name = newRow.incoming_item_name;
          row_incoming_item_spec = newRow.incoming_item_spec;
          row_incoming_package_count = newRow.incoming_package_count;
          row_incoming_pack_rate = newRow.incoming_pack_rate;
          row_incoming_item_count = newRow.incoming_item_count;
          row_incoming_quality_exam_yn = newRow.incoming_quality_exam_yn;
          row_incoming_save_workplace_id = newRow.incoming_save_workplace_id;
          row_incoming_save_workplace_name = newRow.incoming_save_workplace_name;
          row_incoming_save_warehouse_id = newRow.incoming_save_warehouse_id;
          row_incoming_save_warehouse_name = newRow.incoming_save_warehouse_name;
          row_incoming_save_section_id = newRow.incoming_save_section_id;
          row_incoming_save_section_name = newRow.incoming_save_section_name;
        }
      }else{
        itemRows.map((data) => data.id === newRow.id 
          && (data.incoming_item_id !== newRow.incoming_item_id || data.incoming_item_name !== newRow.incoming_item_name 
            || data.incoming_item_spec !== newRow.incoming_item_spec || data.incoming_package_count !== newRow.incoming_package_count || data.incoming_pack_rate !== newRow.incoming_pack_rate || data.incoming_quality_exam_yn !== newRow.incoming_quality_exam_yn
            || data.incoming_save_workplace_id !== newRow.incoming_save_workplace_id || data.incoming_save_warehouse_id !== newRow.incoming_save_warehouse_id
            || data.incoming_save_section_id !== newRow.incoming_save_section_id)?
          (
            row_incoming_item_id = data.incoming_item_id,
            row_incoming_item_name = data.incoming_item_name,
            row_incoming_item_spec = data.incoming_item_spec,
            row_incoming_package_count = data.incoming_package_count,
            row_incoming_pack_rate = data.incoming_pack_rate,
            row_incoming_item_count = data.incoming_item_count,
            row_incoming_quality_exam_yn = data.incoming_quality_exam_yn,
            row_incoming_save_workplace_id = data.incoming_save_workplace_id,
            row_incoming_save_workplace_name = data.incoming_save_workplace_name,
            row_incoming_save_warehouse_id = data.incoming_save_warehouse_id,
            row_incoming_save_warehouse_name = data.incoming_save_warehouse_name,
            row_incoming_save_section_id = data.incoming_save_section_id,
            row_incoming_save_section_name = data.incoming_save_section_name
          ):""
        )
      }
      
      if(row_incoming_item_id === '' && row_incoming_item_name === '' && row_incoming_item_spec === '' && row_incoming_package_count === '' && row_incoming_pack_rate === ''
        && row_incoming_quality_exam_yn === 'N' && row_incoming_save_workplace_id === null && row_incoming_save_warehouse_id === null && row_incoming_save_section_id === null){
        if(updateItemRows.length > 0){
          setUpdateItemRows(updateItemRows.filter((data) => data.id !== newRow.id));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
          createLotRow(itemRows, newNoDataArray, 'A', inputs.incoming_date)
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateItemRows.length; i++) {
          if(updateItemRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          setUpdateItemRows(updateItemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          createLotRow(itemRows, newUpdateDataArray, 'A', inputs.incoming_date)
        }else{
          setUpdateItemRows(prevRows => [...prevRows, newUpdateDataArray]);
          setItemRows(itemRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          createLotRow(itemRows, newUpdateDataArray, 'A', inputs.incoming_date)
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const createLotRow = (tempItemRow, tempNewUpdateData, tempType, changeDate, startNumber = '0') => {
    if (tempType === 'D') {
      setLotRows(prev => prev.filter(r => r.upper_id !== tempNewUpdateData.id));
      setUpdateLotRows(prev => prev.filter(r => r.upper_id !== tempNewUpdateData.id));
      return;
    }

    const now_lot_date_count = startNumber !== '0' ? startNumber : lotNoStartNumber;
    const nextLotRows = [];
    const nextUpdateLotRows = [];
    let nextId = Number(appStore.getMaxListID(lotRows)) + 1;
    let now_lot_no_count = '1';
    const source = tempItemRow && tempItemRow.length > 0 ? tempItemRow : [tempNewUpdateData];

    for (const row of source) {
      const payload = (row.id === tempNewUpdateData?.id && tempNewUpdateData?.id) ? tempNewUpdateData : row;
      now_lot_no_count = buildLotRowsForItem({
        insertData: payload,
        lotDateCount: now_lot_date_count,
        startNo: now_lot_no_count,
        changeDate,
        takeId: () => nextId++, 
        pushLot: (lot) => { nextLotRows.push(lot); nextUpdateLotRows.push({ ...lot }); }
      });
    }

    setLotRows(nextLotRows);
    setUpdateLotRows(nextUpdateLotRows);
  };

  const buildLotRowsForItem = ({ insertData, lotDateCount, startNo, changeDate, takeId, pushLot }) => {
    const count = Number(insertData.incoming_item_count || 0); // 로트는 항상 총 수량(EA) 기준으로 생성
    let cur = Number(startNo);

    if (!insertData.incoming_item_id || count <= 0) return String(cur);

    for (let i = cur; i < cur + count; i++) {
      const tempDate = lotDateCount.toString().padStart(3, '0');
      const tempNo = i.toString().padStart(5, '0');
      const tempLotNo = 'I' + Moment(changeDate).format('YYMMDD') + tempDate + '-' + tempNo;

      const lotRow = {
        id: takeId(),
        upper_id: insertData.id,
        lot_no: tempLotNo,
        lot_incoming_item_id: insertData.incoming_item_id,
        lot_incoming_item_name: insertData.incoming_item_name,
        lot_incoming_item_spec: insertData.incoming_item_spec,
        lot_incoming_quality_exam_yn: insertData.incoming_quality_exam_yn,
        lot_incoming_save_workplace_id: insertData.incoming_save_workplace_id,
        lot_incoming_save_workplace_name: insertData.incoming_save_workplace_name,
        lot_incoming_save_warehouse_id: insertData.incoming_save_warehouse_id,
        lot_incoming_save_warehouse_name: insertData.incoming_save_warehouse_name,
        lot_incoming_save_section_id: insertData.incoming_save_section_id,
        lot_incoming_save_section_name: insertData.incoming_save_section_name,
        row_type: insertData.row_type,
        update_type: insertData.update_type
      };

      pushLot(lotRow);
    }

    return String(cur + count);
  };

  const processLotRowUpdate = (newRow, oldRow) => {
    const newUpdateDataArray = { 
        ...newRow
        , update_type: 'U' }; 
    const newNoDataArray = { 
        ...newRow
        , update_type: 'N' }; 
    
    if(newRow.lot_incoming_save_workplace_id !== oldRow.lot_incoming_save_workplace_id || newRow.lot_incoming_save_warehouse_id !== oldRow.lot_incoming_save_warehouse_id || newRow.lot_incoming_save_section_id !== oldRow.lot_incoming_save_section_id){
      var row_upper_id = 0;
      var row_lot_incoming_item_id = '';
      var row_lot_incoming_item_name = '';
      var row_lot_incoming_item_spec = '';
      var row_lot_incoming_quality_exam_yn = 'N';
      var row_lot_incoming_save_workplace_id = null
      var row_lot_incoming_save_workplace_name = '';
      var row_lot_incoming_save_warehouse_id = null;
      var row_lot_incoming_save_warehouse_name = '';
      var row_lot_incoming_save_section_id = null;
      var row_lot_incoming_save_section_name = '';

      if(String(newRow.row_type) === "A"){
        if(newRow.lot_incoming_save_workplace_id !== null|| newRow.lot_incoming_save_workplace_name !== ''
          || newRow.lot_incoming_save_warehouse_id !== null || newRow.lot_incoming_save_warehouse_name !== ''
          || newRow.lot_incoming_save_section_id !== null || newRow.lot_incoming_save_section_name !== ''){
          row_upper_id = newRow.row_upper_id;
          row_lot_incoming_item_id = newRow.lot_incoming_item_id;
          row_lot_incoming_item_name = newRow.lot_incoming_item_name;
          row_lot_incoming_item_spec = newRow.lot_incoming_item_spec;
          row_lot_incoming_quality_exam_yn = newRow.lot_incoming_quality_exam_yn;
          row_lot_incoming_save_workplace_id = newRow.lot_incoming_save_workplace_id;
          row_lot_incoming_save_workplace_name = newRow.lot_incoming_save_workplace_name;
          row_lot_incoming_save_warehouse_id = newRow.lot_incoming_save_warehouse_id;
          row_lot_incoming_save_warehouse_name = newRow.lot_incoming_save_warehouse_name;
          row_lot_incoming_save_section_id = newRow.lot_incoming_save_section_id;
          row_lot_incoming_save_section_name = newRow.lot_incoming_save_section_name;
        }
      }else{
        lotRows.map((data) => data.id === newRow.id 
          && (data.lot_incoming_save_workplace_id !== newRow.lot_incoming_save_workplace_id
            || data.lot_incoming_save_warehouse_id !== newRow.lot_incoming_save_warehouse_id
            || data.lot_incoming_save_section_id !== newRow.lot_incoming_save_section_id )?
          (
            row_upper_id = data.row_upper_id,
            row_lot_incoming_item_id = data.lot_incoming_item_id,
            row_lot_incoming_item_name = data.lot_incoming_item_name,
            row_lot_incoming_item_spec = data.lot_incoming_item_spec,
            row_lot_incoming_quality_exam_yn = data.lot_incoming_quality_exam_yn,
            row_lot_incoming_save_workplace_id = data.lot_incoming_save_workplace_id,
            row_lot_incoming_save_workplace_name = data.lot_incoming_save_workplace_name,
            row_lot_incoming_save_warehouse_id = data.lot_incoming_save_warehouse_id,
            row_lot_incoming_save_warehouse_name = data.lot_incoming_save_warehouse_name,
            row_lot_incoming_save_section_id = data.lot_incoming_save_section_id,
            row_lot_incoming_save_section_name = data.lot_incoming_save_section_name
          ):""
        )
      }
      
      if(row_lot_incoming_save_workplace_id === null && row_lot_incoming_save_warehouse_id === null && row_lot_incoming_save_section_id === null){
        if(updateLotRows.length > 0){
          setUpdateLotRows(updateLotRows.filter((data) => data.id !== newRow.id));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateLotRows.length; i++) {
          if(updateLotRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          setUpdateLotRows(updateLotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          setUpdateLotRows(prevRows => [...prevRows, newUpdateDataArray]);
          setLotRows(lotRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const processUserRowUpdate = (newRow, oldRow) => {
    const newUpdateDataArray = { ...newRow, update_type: 'U' }; 
    const newNoDataArray = { ...newRow, update_type: 'N' }; 

    if(oldRow.incoming_user_id !== newRow.incoming_user_id || oldRow.incoming_user_type !== newRow.incoming_user_type || oldRow.incoming_user_bigo !== newRow.incoming_user_bigo){
      var row_incoming_user_id = '';
      var row_incoming_user_name = '';
      var row_incoming_user_type = '';
      var row_incoming_user_bigo = '';
      
      if(String(newRow.row_type) === "A"){
        if(newRow.incoming_user_id !== '' || newRow.incoming_user_name !== '' || (newRow.incoming_user_type !== 0 && newRow.incoming_user_type !== '') || newRow.incoming_user_bigo !== '' ){
          row_incoming_user_id = newRow.incoming_user_id;
          row_incoming_user_name = newRow.incoming_user_name;
          row_incoming_user_type = newRow.incoming_user_type;
          row_incoming_user_bigo = newRow.incoming_user_bigo;
        }
      }else{
        userRows.map((data) => data.id === newRow.id 
          && (data.incoming_user_id !== newRow.incoming_user_id || data.incoming_user_name !== newRow.incoming_user_name || data.incoming_user_type !== newRow.incoming_user_type || data.incoming_user_bigo !== newRow.incoming_user_bigo )?
          (
            row_incoming_user_id = data.incoming_user_id,
            row_incoming_user_name = data.incoming_user_name,
            row_incoming_user_type = data.incoming_user_type,
            row_incoming_user_bigo = data.incoming_user_bigo
          ):""
        )
      }
      
      if(row_incoming_user_id === '' && row_incoming_user_name === '' && row_incoming_user_bigo === '' && (row_incoming_user_type === '' || row_incoming_user_type === null)){
        if(updateUserRows.length > 0){
          setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
          setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
        }
        return newNoDataArray;
      }else{
        var updateRowsYN = 'N'; 
        for (let i = 0; i < updateUserRows.length; i++) {
          if(updateUserRows[i].id === newRow.id){
            updateRowsYN = 'Y';
          }
        }

        if(updateRowsYN === 'Y'){
          setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }else{
          setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
          setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
        }
        return newUpdateDataArray;
      }
    }
    return { ...newRow };
  };

  const itemAddClick = (object) => {
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setItemRows((itemRows) => [...itemRows, { 
        id: Number(appStore.getMaxListID(itemRows))+1,
        incoming_item_id: '',
        incoming_item_name: '',
        incoming_item_spec: '',
        incoming_package_count: '',
        incoming_pack_rate: '',
        incoming_item_count: '',
        incoming_quality_exam_yn: 'N',
        incoming_save_workplace_id: null,
        incoming_save_workplace_name: '',
        incoming_save_warehouse_id: null,
        incoming_save_warehouse_name: '',
        incoming_save_section_id: null,
        incoming_save_section_name: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('품목 목록')
      setSelectItemModalOpen(true);
      setSelectItemData({
        id: object.row.id,
        incoming_item_id: object.row.incoming_item_id,
        incoming_item_name: object.row.incoming_item_name,
        incoming_item_spec: object.row.incoming_item_spec,
        incoming_package_count: object.row.incoming_package_count,
        incoming_pack_rate: object.row.incoming_pack_rate,
        incoming_item_count: object.row.incoming_item_count,
        incoming_quality_exam_yn: object.row.incoming_quality_exam_yn,
        incoming_save_workplace_id: object.row.incoming_save_workplace_id,
        incoming_save_workplace_name: object.row.incoming_save_workplace_name,
        incoming_save_warehouse_id: object.row.incoming_save_warehouse_id,
        incoming_save_warehouse_name: object.row.incoming_save_warehouse_name,
        incoming_save_section_id: object.row.incoming_save_section_id,
        incoming_save_section_name: object.row.incoming_save_section_name,
        row_type: object.row.row_type,
        update_type: object.row.update_type,
      })
    }
  };

  const itemDeleteClick = (object) => {
    setUpdateItemRows((updateItemRows) => updateItemRows.filter((data) => data.id !== object.row.id));
    setItemRows((itemRows) => itemRows.filter((data) => data.id !== object.row.id));
    createLotRow(itemRows,object.row,'D','')
  };

  const userAddClick = (object) => {
    if(object.row.row_type !== 'A' || object.row.update_type !== 'N'){
      setUserRows((userRows) => [...userRows, { 
        id: Number(appStore.getMaxListID(userRows))+1,
        incoming_user_id: '',
        incoming_user_name: '',
        incoming_user_dept_name: '',
        incoming_user_position_name: '',
        incoming_user_type: '',
        incoming_user_bigo: '',
        row_type:'A',
        update_type: 'N'
      }]);
    }else{
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: object.row.id,
        incoming_user_id: object.row.incoming_user_id,
        incoming_user_name: object.row.incoming_user_name,
        incoming_user_dept_name: object.row.incoming_user_dept_name,
        incoming_user_position_name: object.row.incoming_user_position_name,
        incoming_user_type: object.row.incoming_user_type,
        incoming_user_bigo: object.row.incoming_user_bigo,
        row_type: object.row.row_type,
        update_type: object.row.update_type
      })
    }
  };

  const userDeleteClick = (object) => {
    setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
    setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
  };

  const fileAddClick = (object) => {
    const input=document.createElement('input');
    input.type="file";
    input.multiple = true;
    input.style.display = 'none';
    document.body.appendChild(input);
    input.click();
    input.onchange = () => {

      for(var i=0; i<input.files.length; i++){
        realFiles.push(input.files[i]);
      }
      
      var array = [];
      for(var i=0; i<realFiles.length; i++){
        var tmp_sever_file_name = realFiles[i].name;
        var tmp_file_name = realFiles[i].name;
        var tmp_file_size = realFiles[i].size;
        var tmp_file_size_dp = appStore.convertFileSize(realFiles[i].size);
        var tmp_file_type = realFiles[i].type;
        var tmp_file_type_name  = appStore.convertFileTypeName(realFiles[i].type);
        var tmp_file_extension = tmp_sever_file_name.substring(tmp_sever_file_name.lastIndexOf('.')+1, tmp_sever_file_name.length);

        array.push({
          id: newFileID,
          file_name_sever: tmp_sever_file_name,
          file_size: tmp_file_size,
          file_type: tmp_file_type,
          file_extension: tmp_file_extension,
          file_type_name: tmp_file_type_name,
          file_name: tmp_file_name,
          file_size_dp: tmp_file_size_dp,
          reg_user_name: '',
          reg_datetime: '',
          row_type:'A',
          update_type: 'U'
        })
        newFileID = newFileID + 1;
      }
      setFileRows(array);
    }
  };

  const fileDeleteClick = (object) => {
    for(let i = 0; i < realFiles.length; i++) {
      if (realFiles[i].name === object.row.file_name_sever) {
        realFiles.splice(i, 1);
        break;
      }
    }
    setUpdateFileRows((updateFileRows) => updateFileRows.filter((data) => data.id !== object.row.id));
    setFileRows((fileRows) => fileRows.filter((data) => data.id !== object.row.id));
  };

  const fileDownloadClick = (object) => {
  };

  const handlePurchaseRef = (event) => {
    setSelectModalTitle('발주 목록')
    setSelectPurchaseModalOpen(true);
  }

  const handleIncomingRef = (event) => {
    setSelectModalTitle('입고 목록')
    setSelectIncomingModalOpen(true);
  }

  const handleOnCellClick = (params) => {
    if(params.field === 'incoming_item_name' || params.field === 'incoming_item_spec' 
      || params.field === 'incoming_save_workplace_name' || params.field === 'incoming_save_warehouse_name' || params.field === 'incoming_save_section_name'){
      if(params.field === 'incoming_item_name' || params.field === 'incoming_item_spec'){
        setSelectModalTitle('품목 목록');
        setSelectItemModalOpen(true);
      } else if(params.field === 'incoming_save_workplace_name' || params.field === 'incoming_save_warehouse_name' || params.field === 'incoming_save_section_name'){
        setSelectModalTitle('창고 목록');
        setSelectWarehouseModalOpen(true);
      }
      setSelectModalType('I') 
      setSelectItemData({
        id: params.row.id,
        incoming_item_id: params.row.incoming_item_id,
        incoming_item_name: params.row.incoming_item_name,
        incoming_item_spec: params.row.incoming_item_spec,
        incoming_package_count: params.row.incoming_package_count,
        incoming_pack_rate: params.row.incoming_pack_rate,
        incoming_item_count: params.row.incoming_item_count,
        incoming_quality_exam_yn: params.row.incoming_quality_exam_yn,
        incoming_save_workplace_id: params.row.incoming_save_workplace_id,
        incoming_save_workplace_name: params.row.incoming_save_workplace_name,
        incoming_save_warehouse_id: params.row.incoming_save_warehouse_id,
        incoming_save_warehouse_name: params.row.incoming_save_warehouse_name,
        incoming_save_section_id: params.row.incoming_save_section_id,
        incoming_save_section_name: params.row.incoming_save_section_name,
        row_type:params.row.row_type,
        update_type: params.row.update_type,
      })
    } else if(params.field === 'incoming_user_name'){
      setSelectModalTitle('사용자 목록')
      setSelectUserModalOpen(true);
      setSelectUserData({
        id: params.row.id,
        incoming_user_id: params.row.incoming_user_id,
        incoming_user_name: params.row.incoming_user_name,
        incoming_user_dept_name: params.row.incoming_user_dept_name,
        incoming_user_position_name: params.row.incoming_user_position_name,
        incoming_user_type: params.row.incoming_user_type,
        incoming_user_bigo: params.row.incoming_user_bigo,
        row_type: params.row.row_type,
        update_type: params.row.update_type
      })
    } else if(params.field === 'lot_incoming_save_workplace_name' || params.field === 'lot_incoming_save_warehouse_name' || params.field === 'lot_incoming_save_section_name'){
      setSelectModalTitle('창고 목록');
      setSelectWarehouseModalOpen(true);
      setSelectModalType('L') 
      setSelectLotData({
        id: params.row.id,
        upper_id: params.row.upper_id,
        lot_no: params.row.lot_no,
        lot_incoming_item_id: params.row.lot_incoming_item_id,
        lot_incoming_item_name: params.row.lot_incoming_item_name,
        lot_incoming_item_spec: params.row.lot_incoming_item_spec,
        lot_incoming_quality_exam_yn: params.row.lot_incoming_quality_exam_yn,
        lot_incoming_save_workplace_id: params.row.lot_incoming_save_workplace_id,
        lot_incoming_save_workplace_name: params.row.lot_incoming_save_workplace_name,
        lot_incoming_save_warehouse_id: params.row.lot_incoming_save_warehouse_id,
        lot_incoming_save_warehouse_name: params.row.lot_incoming_save_warehouse_name,
        lot_incoming_save_section_id: params.row.lot_incoming_save_section_id,
        lot_incoming_save_section_name: params.row.lot_incoming_save_section_name,
        row_type: params.row.row_type,
        update_type: params.row.update_type,
      })
    }
  };

  const handlePurchaseClick = (object) => {
    if(object.length !== 0){
      Swal.fire({
        title: '발주번호 '+object[0].purchase_number+' 입고 등록',
        text: '확인버튼을 클릭하면 발주정보와 연결됩니다.',
        showCancelButton: true,
        confirmButtonText: '확인', 
        cancelButtonText: '취소',
        confirmButtonColor: '#0067a3',
        cancelButtonColor: '#d33',
      }).then(result => {
          if (result.isConfirmed) {
            setLotRows([]);
            setUpdateLotRows([]);
            
            setInputs({
              incoming_id: null,
              incoming_number: '',
              incoming_date: appStore.YYYY_MM_DD(),
              incoming_partner_id: Number(object[0].purchase_partner_id),
              incoming_partner_name: object[0].purchase_partner_name,
              incoming_partner_manager: object[0].purchase_partner_manager,
              incoming_partner_manager_phone: object[0].purchase_partner_manager_phone,
              incoming_partner_manager_mail: object[0].purchase_partner_manager_mail,
              incoming_bigo: object[0].purchase_bigo,
              incoming_purchase_id: Number(object[0].purchase_id),
              incoming_purchase_number: object[0].purchase_number,
              incoming_ref_incoming_id: null,
            });
        
            var itemData = object.filter((item, index) => {
              return (
                object.findIndex((item2, index2) => {
                  return typeof item.purchase_item_seq !== 'undefined' && item.purchase_item_seq === item2.purchase_item_seq;
                }) === index
              );
            });
        
            setItemRows(itemData.map((item, index) => ({
              id: item.purchase_item_seq,
              incoming_item_id: item.purchase_item_id,
              incoming_item_name: item.purchase_item_name,
              incoming_item_spec: item.purchase_item_spec === ''? '' : appStore.ITEM_FULL_SPEC_MAKE(item.purchase_item_spec, item.purchase_item_width, item.purchase_item_depth, item.purchase_item_height),
              incoming_package_count: item.purchase_package_count,
              incoming_pack_rate: item.purchase_pack_rate,
              incoming_item_count: item.purchase_item_count,
              incoming_quality_exam_yn: 'N',
              incoming_save_workplace_id: item.purchase_item_save_workplace_id,
              incoming_save_workplace_name: item.purchase_item_save_workplace_name,
              incoming_save_warehouse_id: item.purchase_item_save_warehouse_id,
              incoming_save_warehouse_name: item.purchase_item_save_warehouse_name,
              incoming_save_section_id: item.purchase_item_save_section_id,
              incoming_save_section_name: item.purchase_item_save_section_name,
              row_type: 'A',
              update_type: 'U'
            })));

            setUpdateItemRows(itemData.map((item, index) => ({
              id: item.purchase_item_seq,
              incoming_item_id: item.purchase_item_id,
              incoming_item_name: item.purchase_item_name,
              incoming_item_spec: item.purchase_item_spec === ''? '' : appStore.ITEM_FULL_SPEC_MAKE(item.purchase_item_spec, item.purchase_item_width, item.purchase_item_depth, item.purchase_item_height),
              incoming_package_count: item.purchase_package_count,
              incoming_pack_rate: item.purchase_pack_rate,
              incoming_item_count: item.purchase_item_count,
              incoming_quality_exam_yn: 'N',
              incoming_save_workplace_id: item.purchase_item_save_workplace_id,
              incoming_save_workplace_name: item.purchase_item_save_workplace_name,
              incoming_save_warehouse_id: item.purchase_item_save_warehouse_id,
              incoming_save_warehouse_name: item.purchase_item_save_warehouse_name,
              incoming_save_section_id: item.purchase_item_save_section_id,
              incoming_save_section_name: item.purchase_item_save_section_name,
              row_type: 'A',
              update_type: 'U'
            })));

            var itemTempData = [];
            for(let i = 0; i < itemData.length; i++){ 
              var tempData = {
                id: itemData[i].purchase_item_seq,
                incoming_item_id: itemData[i].purchase_item_id,
                incoming_item_name: itemData[i].purchase_item_name,
                incoming_item_spec: itemData[i].purchase_item_spec === ''? '' : appStore.ITEM_FULL_SPEC_MAKE(itemData[i].purchase_item_spec, itemData[i].purchase_item_width, itemData[i].purchase_item_depth, itemData[i].purchase_item_height),
                incoming_package_count: itemData[i].purchase_package_count,
                incoming_pack_rate: itemData[i].purchase_pack_rate,
                incoming_item_count: itemData[i].purchase_item_count,
                incoming_quality_exam_yn: 'N',
                incoming_save_workplace_id: itemData[i].purchase_item_save_workplace_id,
                incoming_save_workplace_name: itemData[i].purchase_item_save_workplace_name,
                incoming_save_warehouse_id: itemData[i].purchase_item_save_warehouse_id,
                incoming_save_warehouse_name: itemData[i].purchase_item_save_warehouse_name,
                incoming_save_section_id: itemData[i].purchase_item_save_section_id,
                incoming_save_section_name: itemData[i].purchase_item_save_section_name,
                row_type: 'A',
                update_type: 'U'
              }
              itemTempData = itemTempData.concat(tempData);
            }

            createLotRow(itemTempData, {}, 'A', appStore.YYYY_MM_DD());

            var userData = object.filter((item, index) => {
              return (
                object.findIndex((item2, index2) => {
                  return typeof item.purchase_user_seq !== 'undefined' && item.purchase_user_seq === item2.purchase_user_seq;
                }) === index
              );
            });

            setUserRows(userData.map((item, index) => ({
              id: item.purchase_user_seq,
              incoming_user_id: item.purchase_user_id,
              incoming_user_name: item.purchase_user_name,
              incoming_user_dept_name: item.purchase_user_dept_name,
              incoming_user_position_name: item.purchase_user_position_name,
              incoming_user_type: item.purchase_user_type,
              incoming_user_bigo: item.purchase_user_bigo,
              row_type: 'A',
              update_type: 'U'
            })));

            setUpdateUserRows(userData.map((item, index) => ({
              id: item.purchase_user_seq,
              incoming_user_id: item.purchase_user_id,
              incoming_user_name: item.purchase_user_name,
              incoming_user_dept_name: item.purchase_user_dept_name,
              incoming_user_position_name: item.purchase_user_position_name,
              incoming_user_type: item.purchase_user_type,
              incoming_user_bigo: item.purchase_user_bigo,
              row_type: 'A',
              update_type: 'U'
            })));

          } else if (result.isDismissed) {
            const nextInputs = {
                ...inputs,
                ["incoming_purchase_id"]: null,
                ["incoming_purchase_number"]: ''
            };
            setInputs(nextInputs);
          }

      })
    }else{
      setInputs({
        incoming_id: null,
        incoming_number: '',
        incoming_date: appStore.YYYY_MM_DD(),
        incoming_partner_id: 0,
        incoming_partner_name: '',
        incoming_partner_manager: '',
        incoming_partner_manager_phone: '',
        incoming_partner_manager_mail: '',
        incoming_bigo: '',
        incoming_purchase_id: null,
        incoming_purchase_number: '',
        incoming_ref_incoming_id: null,
      });

      setItemRows([]);
      setUpdateItemRows([]);
      setUserRows([]);
      setUpdateUserRows([]);
    }
  }

  const handleIncomingClick = (object) => {
    if(object.length !== 0){
      Swal.fire({
        title: '입고번호 '+object[0].incoming_number+' 복사',
        text: '확인버튼을 클릭하면 입고정보가 복사됩니다.',
        showCancelButton: true,
        confirmButtonText: '확인', 
        cancelButtonText: '취소',
        confirmButtonColor: '#0067a3',
        cancelButtonColor: '#d33',
      }).then(result => {
        if (result.isConfirmed) {
          setLotRows([]);
          setUpdateLotRows([]);

          setInputs({
            incoming_id: null,
            incoming_number: '',
            incoming_date: appStore.YYYY_MM_DD(),
            incoming_partner_id: Number(object[0].incoming_partner_id),
            incoming_partner_name: object[0].incoming_partner_name,
            incoming_partner_manager: object[0].incoming_partner_manager,
            incoming_partner_manager_phone: object[0].incoming_partner_manager_phone,
            incoming_partner_manager_mail: object[0].incoming_partner_manager_mail,
            incoming_bigo: object[0].incoming_bigo,
            incoming_purchase_id: null,
            incoming_purchase_number: '',
            incoming_ref_incoming_id: Number(object[0].incoming_id),
          });
      
          var itemData = object.filter((item, index) => {
            return (
              object.findIndex((item2, index2) => {
                return typeof item.incoming_item_seq !== 'undefined' && item.incoming_item_seq === item2.incoming_item_seq;
              }) === index
            );
          });
      
          setItemRows(itemData.map((item, index) => ({
            id: item.incoming_item_seq,
            incoming_item_id: item.incoming_item_id,
            incoming_item_name: item.incoming_item_name,
            incoming_item_spec: item.incoming_item_spec === ''? '' : appStore.ITEM_FULL_SPEC_MAKE(item.incoming_item_spec, item.incoming_item_width, item.incoming_item_depth, item.incoming_item_height),
            incoming_package_count: item.incoming_package_count,
            incoming_pack_rate: item.incoming_pack_rate,
            incoming_item_count: item.incoming_item_count,
            incoming_quality_exam_yn: item.incoming_quality_exam_yn,
            incoming_save_workplace_id: item.incoming_save_workplace_id,
            incoming_save_workplace_name: item.incoming_save_workplace_name,
            incoming_save_warehouse_id: item.incoming_save_warehouse_id,
            incoming_save_warehouse_name: item.incoming_save_warehouse_name,
            incoming_save_section_id: item.incoming_save_section_id,
            incoming_save_section_name: item.incoming_save_section_name,
            row_type: 'A',
            update_type: 'U'
          })));
          
          setUpdateItemRows(itemData.map((item, index) => ({
            id: item.incoming_item_seq,
            incoming_item_id: item.incoming_item_id,
            incoming_item_name: item.incoming_item_name,
            incoming_item_spec: item.incoming_item_spec === ''? '' : appStore.ITEM_FULL_SPEC_MAKE(item.incoming_item_spec, item.incoming_item_width, item.incoming_item_depth, item.incoming_item_height),
            incoming_package_count: item.incoming_package_count,
            incoming_pack_rate: item.incoming_pack_rate,
            incoming_item_count: item.incoming_item_count,
            incoming_quality_exam_yn: item.incoming_quality_exam_yn,
            incoming_save_workplace_id: item.incoming_save_workplace_id,
            incoming_save_workplace_name: item.incoming_save_workplace_name,
            incoming_save_warehouse_id: item.incoming_save_warehouse_id,
            incoming_save_warehouse_name: item.incoming_save_warehouse_name,
            incoming_save_section_id: item.incoming_save_section_id,
            incoming_save_section_name: item.incoming_save_section_name,
            row_type: 'A',
            update_type: 'U'
          })));

          // lot grid 데이터 업데이트 
          var itemTempData = [];
          for(let i = 0; i < itemData.length; i++){ 
            var tempData = {
              id: itemData[i].incoming_item_seq,
              incoming_item_id: itemData[i].incoming_item_id,
              incoming_item_name: itemData[i].incoming_item_name,
              incoming_item_spec: itemData[i].incoming_item_spec === ''? '' : appStore.ITEM_FULL_SPEC_MAKE(itemData[i].incoming_item_spec, itemData[i].incoming_item_width, itemData[i].incoming_item_depth, itemData[i].incoming_item_height),
              incoming_package_count: itemData[i].incoming_package_count,
              incoming_pack_rate: itemData[i].incoming_pack_rate,
              incoming_item_count: itemData[i].incoming_item_count,
              incoming_quality_exam_yn: itemData[i].incoming_quality_exam_yn,
              incoming_save_workplace_id: itemData[i].incoming_save_workplace_id,
              incoming_save_workplace_name: itemData[i].incoming_save_workplace_name,
              incoming_save_warehouse_id: itemData[i].incoming_save_warehouse_id,
              incoming_save_warehouse_name: itemData[i].incoming_save_warehouse_name,
              incoming_save_section_id: itemData[i].incoming_save_section_id,
              incoming_save_section_name: itemData[i].incoming_save_section_name,
              row_type: 'A',
              update_type: 'U'
            }
            itemTempData = itemTempData.concat(tempData);
          }

          createLotRow(itemTempData, {}, 'A', appStore.YYYY_MM_DD());

          var userData = object.filter((item, index) => {
            return (
              object.findIndex((item2, index2) => {
                return typeof item.incoming_user_seq !== 'undefined' && item.incoming_user_seq === item2.incoming_user_seq;
              }) === index
            );
          });

          setUserRows(userData.map((item, index) => ({
            id: item.incoming_user_seq,
            incoming_user_id: item.incoming_user_id,
            incoming_user_name: item.incoming_user_name,
            incoming_user_dept_name: item.incoming_user_dept_name,
            incoming_user_position_name: item.incoming_user_position_name,
            incoming_user_type: item.incoming_user_type,
            incoming_user_bigo: item.incoming_user_bigo,
            row_type: 'A',
            update_type: 'U'
          })));

          setUpdateUserRows(userData.map((item, index) => ({
            id: item.incoming_user_seq,
            incoming_user_id: item.incoming_user_id,
            incoming_user_name: item.incoming_user_name,
            incoming_user_dept_name: item.incoming_user_dept_name,
            incoming_user_position_name: item.incoming_user_position_name,
            incoming_user_type: item.incoming_user_type,
            incoming_user_bigo: item.incoming_user_bigo,
            row_type: 'A',
            update_type: 'U'
          })));

        } else if (result.isDismissed) {
          const nextInputs = {
              ...inputs,
              ["incoming_ref_incoming_id"]: null,
          };
          setInputs(nextInputs);
        }
      })
    }else{
      setInputs({
        incoming_id: null,
        incoming_number: '',
        incoming_date: appStore.YYYY_MM_DD(),
        incoming_partner_id: 0,
        incoming_partner_name: '',
        incoming_partner_manager: '',
        incoming_partner_manager_phone: '',
        incoming_partner_manager_mail: '',
        incoming_bigo: '',
        incoming_purchase_id: null,
        incoming_purchase_number: '',
        incoming_ref_incoming_id: null,
      });

      setItemRows([]);
      setUpdateItemRows([]);
      setLotRows([]);
      setUpdateLotRows([]);
      setUserRows([]);
      setUpdateUserRows([]);
    }
  }

  const handlePartnerUserClick = (object) => {
    var partner_user_name = object.partner_user_name === undefined?'':object.partner_user_name
    var partner_user_phone = object.partner_user_phone === undefined?'':object.partner_user_phone
    var partner_user_email = object.partner_user_email === undefined?'':object.partner_user_email

    const nextInputs = {
        ...inputs,
        ["incoming_partner_id"]: object.id,
        ["incoming_partner_name"]: object.partner_name,
        ["incoming_partner_manager"]: partner_user_name,
        ["incoming_partner_manager_phone"]: partner_user_phone,
        ["incoming_partner_manager_mail"]: partner_user_email,
        ["incoming_purchase_id"]: null,
        ["incoming_ref_incoming_id"]: null
    };
    setInputs(nextInputs);
  };
  
  const handleInputItemClick = (object) => {
    let item_id = object.id
    var doubleYN = 'N'
    for(let i = 0; i < itemRows.length; i++){
      if(itemRows[i].incoming_item_id === object.id && selectItemData.id !== itemRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">품목 '+object.item_name+' 중복</p>',
        text: '추가된 품목이므로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectItemData.incoming_item_id){
        if (object.id === '') {
          processItemRowUpdate({
            id: selectItemData.id, incoming_item_id: '', incoming_item_name: '', incoming_item_spec: '', incoming_package_count: '', incoming_pack_rate: '', incoming_item_count: '',
            incoming_quality_exam_yn: 'N', incoming_save_workplace_id: null, incoming_save_workplace_name: '', incoming_save_warehouse_id: null,
            incoming_save_warehouse_name: '', incoming_save_section_id: null, incoming_save_section_name: '',
            row_type: selectItemData.row_type, update_type: selectItemData.update_type,
          }, { ...selectItemData });
        } else {
          processItemRowUpdate(
            {
              id: selectItemData.id,
              incoming_item_id: object.id,
              incoming_item_name: object.item_name,
              incoming_item_spec: object.item_spec=== ''? '' : appStore.ITEM_FULL_SPEC_MAKE(object.item_spec, object.item_width, object.item_depth, object.item_height),
              incoming_package_count: selectItemData.incoming_package_count,
              incoming_pack_rate: object.item_incoming_package_count || 1, // 품목 마스터의 입고포장비율 맵핑
              incoming_item_count: Number(selectItemData.incoming_package_count || 0) * Number(object.item_incoming_package_count || 1),
              incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
              incoming_save_workplace_id: object.item_save_workplace_id,
              incoming_save_workplace_name: object.item_save_workplace_name,
              incoming_save_warehouse_id: object.item_save_warehouse_id,
              incoming_save_warehouse_name: object.item_save_warehouse_name,
              incoming_save_section_id: object.item_save_section_id,
              incoming_save_section_name: object.item_save_section_name,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            },
            {
              id: selectItemData.id,
              incoming_item_id: selectItemData.incoming_item_id,
              incoming_item_name: selectItemData.incoming_item_name,
              incoming_item_spec: selectItemData.incoming_item_spec,
              incoming_package_count: selectItemData.incoming_package_count,
              incoming_pack_rate: selectItemData.incoming_pack_rate,
              incoming_item_count: selectItemData.incoming_item_count,
              incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
              incoming_save_workplace_id: selectItemData.incoming_save_workplace_id,
              incoming_save_workplace_name: selectItemData.incoming_save_workplace_name,
              incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
              incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
              incoming_save_section_id: selectItemData.incoming_save_section_id,
              incoming_save_section_name: selectItemData.incoming_save_section_name,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            }
          )
        }
      }
    }
  };

  const handleWorkplaceClick = (object) => {
    if(selectModalType === 'I') { 
      if(object.id !== selectItemData.incoming_save_workplace_id){
        processItemRowUpdate(
          {
            id: selectItemData.id,
            incoming_item_id: selectItemData.incoming_item_id,
            incoming_item_name: selectItemData.incoming_item_name,
            incoming_item_spec: selectItemData.incoming_item_spec,
            incoming_package_count: selectItemData.incoming_package_count,
            incoming_pack_rate: selectItemData.incoming_pack_rate,
            incoming_item_count: selectItemData.incoming_item_count,
            incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
            incoming_save_workplace_id: object.id,
            incoming_save_workplace_name: object.workplace_name,
            incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
            incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
            incoming_save_section_id: selectItemData.incoming_save_section_id,
            incoming_save_section_name: selectItemData.incoming_save_section_name,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          },
          {
            id: selectItemData.id,
            incoming_item_id: selectItemData.incoming_item_id,
            incoming_item_name: selectItemData.incoming_item_name,
            incoming_item_spec: selectItemData.incoming_item_spec,
            incoming_package_count: selectItemData.incoming_package_count,
            incoming_pack_rate: selectItemData.incoming_pack_rate,
            incoming_item_count: selectItemData.incoming_item_count,
            incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
            incoming_save_workplace_id: selectItemData.incoming_save_workplace_id,
            incoming_save_workplace_name: selectItemData.incoming_save_workplace_name,
            incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
            incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
            incoming_save_section_id: selectItemData.incoming_save_section_id,
            incoming_save_section_name: selectItemData.incoming_save_section_name,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          }
        )
      }
    } else if(selectModalType === 'L'){ 
      if(object.id !== selectLotData.lot_incoming_save_workplace_id){
        processLotRowUpdate(
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_incoming_item_id: selectLotData.lot_incoming_item_id,
            lot_incoming_item_name: selectLotData.lot_incoming_item_name,
            lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
            lot_incoming_item_count: selectLotData.lot_incoming_item_count,
            lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
            lot_incoming_save_workplace_id: object.id,
            lot_incoming_save_workplace_name: object.workplace_name,
            lot_incoming_save_warehouse_id: selectLotData.lot_incoming_save_warehouse_id,
            lot_incoming_save_warehouse_name: selectLotData.lot_incoming_save_warehouse_name,
            lot_incoming_save_section_id: selectLotData.lot_incoming_save_section_id,
            lot_incoming_save_section_name: selectLotData.lot_incoming_save_section_name,
            row_type:selectLotData.row_type,
            update_type: selectLotData.update_type,
          },
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_incoming_item_id: selectLotData.lot_incoming_item_id,
            lot_incoming_item_name: selectLotData.lot_incoming_item_name,
            lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
            lot_incoming_item_count: selectLotData.lot_incoming_item_count,
            lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
            lot_incoming_save_workplace_id: selectLotData.lot_incoming_save_workplace_id,
            lot_incoming_save_workplace_name: selectLotData.lot_incoming_save_workplace_name,
            lot_incoming_save_warehouse_id: selectLotData.lot_incoming_save_warehouse_id,
            lot_incoming_save_warehouse_name: selectLotData.lot_incoming_save_warehouse_name,
            lot_incoming_save_section_id: selectLotData.lot_incoming_save_section_id,
            lot_incoming_save_section_name: selectLotData.lot_incoming_save_section_name,
            row_type:selectLotData.row_type,
            update_type: selectLotData.update_type,
          }
        )
      }
    }
  };

  const handleWarehouseClick = (object) => {
    if(selectModalType === 'I') { 
      if((object.id !== selectItemData.incoming_save_warehouse_id) || object.section_cnt !== 0){
        if(object.section_cnt !== 0){ 
          setSelectModalTitle('구역 목록');
          setUpperWarehouseId(object.id);
          const nextSelectItemData = { 
            ...selectItemData,
            ['incoming_save_workplace_id'] : object.workplace_id,
            ['incoming_save_workplace_name'] : object.workplace_name,
            ['incoming_save_warehouse_id'] : object.id,
            ['incoming_save_warehouse_name'] : object.warehouse_name
          };
          setSelectItemData(nextSelectItemData);
          setSelectWarehouseSectionModalOpen(true);
        } else if (object.section_cnt === 0){
          processItemRowUpdate(
            {
              id: selectItemData.id,
              incoming_item_id: selectItemData.incoming_item_id,
              incoming_item_name: selectItemData.incoming_item_name,
              incoming_item_spec: selectItemData.incoming_item_spec,
              incoming_package_count: selectItemData.incoming_package_count,
              incoming_pack_rate: selectItemData.incoming_pack_rate,
              incoming_item_count: selectItemData.incoming_item_count,
              incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
              incoming_save_workplace_id: object.workplace_id,
              incoming_save_workplace_name: object.workplace_name,
              incoming_save_warehouse_id: object.id,
              incoming_save_warehouse_name: object.warehouse_name,
              incoming_save_section_id: null,
              incoming_save_section_name: '',
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            },
            {
              id: selectItemData.id,
              incoming_item_id: selectItemData.incoming_item_id,
              incoming_item_name: selectItemData.incoming_item_name,
              incoming_item_spec: selectItemData.incoming_item_spec,
              incoming_package_count: selectItemData.incoming_package_count,
              incoming_pack_rate: selectItemData.incoming_pack_rate,
              incoming_item_count: selectItemData.incoming_item_count,
              incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
              incoming_save_workplace_id: selectItemData.incoming_save_workplace_id,
              incoming_save_workplace_name: selectItemData.incoming_save_workplace_name,
              incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
              incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
              incoming_save_section_id: selectItemData.incoming_save_section_id,
              incoming_save_section_name: selectItemData.incoming_save_section_name,
              row_type:selectItemData.row_type,
              update_type: selectItemData.update_type,
            }
          )
        }
      }
    } else if(selectModalType === 'L'){ 
      if((object.id !== selectLotData.lot_incoming_save_warehouse_id) || object.section_cnt !== 0){
        if(object.section_cnt !== 0){ 
          setSelectModalTitle('구역 목록');
          setUpperWarehouseId(object.id);
          const nextSelectLotData = { 
            ...selectLotData,
            ['lot_incoming_save_workplace_id'] : object.workplace_id,
            ['lot_incoming_save_workplace_name'] : object.workplace_name,
            ['lot_incoming_save_warehouse_id'] : object.id,
            ['lot_incoming_save_warehouse_name'] : object.warehouse_name
          };
          setSelectLotData(nextSelectLotData);
          setSelectWarehouseSectionModalOpen(true);
        } else if (object.section_cnt === 0){
          processLotRowUpdate(
            {
              id: selectLotData.id,
              upper_id: selectLotData.upper_id,
              lot_no: selectLotData.lot_no,
              lot_incoming_item_id: selectLotData.lot_incoming_item_id,
              lot_incoming_item_name: selectLotData.lot_incoming_item_name,
              lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
              lot_incoming_item_count: selectLotData.lot_incoming_item_count,
              lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
              lot_incoming_save_workplace_id: object.workplace_id,
              lot_incoming_save_workplace_name: object.workplace_name,
              lot_incoming_save_warehouse_id: object.id,
              lot_incoming_save_warehouse_name: object.warehouse_name,
              lot_incoming_save_section_id: '',
              lot_incoming_save_section_name: '',
              row_type:selectLotData.row_type,
              update_type: selectLotData.update_type,
            },
            {
              id: selectLotData.id,
              upper_id: selectLotData.upper_id,
              lot_no: selectLotData.lot_no,
              lot_incoming_item_id: selectLotData.lot_incoming_item_id,
              lot_incoming_item_name: selectLotData.lot_incoming_item_name,
              lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
              lot_incoming_item_count: selectLotData.lot_incoming_item_count,
              lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
              lot_incoming_save_workplace_id: selectLotData.lot_incoming_save_workplace_id,
              lot_incoming_save_workplace_name: selectLotData.lot_incoming_save_workplace_name,
              lot_incoming_save_warehouse_id: selectLotData.lot_incoming_save_warehouse_id,
              lot_incoming_save_warehouse_name: selectLotData.lot_incoming_save_warehouse_name,
              lot_incoming_save_section_id: selectLotData.lot_incoming_save_section_id,
              lot_incoming_save_section_name: selectLotData.lot_incoming_save_section_name,
              row_type:selectLotData.row_type,
              update_type: selectLotData.update_type,
            }
          )
        }
      }
    }
  };

  const handleWarehouseSectionClick = (object) => {
    if(selectModalType === 'I') { 
      if(object.id !== selectItemData.incoming_save_section_id){
        processItemRowUpdate(
          {
            id: selectItemData.id,
            incoming_item_id: selectItemData.incoming_item_id,
            incoming_item_name: selectItemData.incoming_item_name,
            incoming_item_spec: selectItemData.incoming_item_spec,
            incoming_package_count: selectItemData.incoming_package_count,
            incoming_pack_rate: selectItemData.incoming_pack_rate,
            incoming_item_count: selectItemData.incoming_item_count,
            incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
            incoming_save_workplace_id: selectItemData.incoming_save_workplace_id,
            incoming_save_workplace_name: selectItemData.incoming_save_workplace_name,
            incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
            incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
            incoming_save_section_id: object.id,
            incoming_save_section_name: object.section_name,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          },
          {
            id: selectItemData.id,
            incoming_item_id: selectItemData.incoming_item_id,
            incoming_item_name: selectItemData.item_name,
            incoming_item_spec: selectItemData.incoming_item_spec,
            incoming_package_count: selectItemData.incoming_package_count,
            incoming_pack_rate: selectItemData.incoming_pack_rate,
            incoming_item_count: selectItemData.incoming_item_count,
            incoming_quality_exam_yn: selectItemData.incoming_quality_exam_yn,
            incoming_save_workplace_id: selectItemData.incoming_save_workplace_id,
            incoming_save_workplace_name: selectItemData.incoming_save_workplace_name,
            incoming_save_warehouse_id: selectItemData.incoming_save_warehouse_id,
            incoming_save_warehouse_name: selectItemData.incoming_save_warehouse_name,
            incoming_save_section_id: selectItemData.incoming_save_section_id,
            incoming_save_section_name: selectItemData.incoming_save_section_name,
            row_type:selectItemData.row_type,
            update_type: selectItemData.update_type,
          }
        )
      }
    } else if(selectModalType === 'L'){ 
      if(object.id !== selectLotData.lot_incoming_save_section_id){
        processLotRowUpdate(
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_incoming_item_id: selectLotData.lot_incoming_item_id,
            lot_incoming_item_name: selectLotData.lot_incoming_item_name,
            lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
            lot_incoming_item_count: selectLotData.lot_incoming_item_count,
            lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
            lot_incoming_save_workplace_id: selectLotData.lot_incoming_save_workplace_id,
            lot_incoming_save_workplace_name: selectLotData.lot_incoming_save_workplace_name,
            lot_incoming_save_warehouse_id: selectLotData.lot_incoming_save_warehouse_id,
            lot_incoming_save_warehouse_name: selectLotData.lot_incoming_save_warehouse_name,
            lot_incoming_save_section_id: object.id,
            lot_incoming_save_section_name: object.section_name,
            row_type:selectLotData.row_type,
            update_type: selectLotData.update_type,
          },
          {
            id: selectLotData.id,
            upper_id: selectLotData.upper_id,
            lot_no: selectLotData.lot_no,
            lot_incoming_item_id: selectLotData.lot_incoming_item_id,
            lot_incoming_item_name: selectLotData.lot_incoming_item_name,
            lot_incoming_item_spec: selectLotData.lot_incoming_item_spec,
            lot_incoming_item_count: selectLotData.lot_incoming_item_count,
            lot_incoming_quality_exam_yn: selectLotData.lot_incoming_quality_exam_yn,
            lot_incoming_save_workplace_id: selectLotData.lot_incoming_save_workplace_id,
            lot_incoming_save_workplace_name: selectLotData.lot_incoming_save_workplace_name,
            lot_incoming_save_warehouse_id: selectLotData.lot_incoming_save_warehouse_id,
            lot_incoming_save_warehouse_name: selectLotData.lot_incoming_save_warehouse_name,
            lot_incoming_save_section_id: selectLotData.lot_incoming_save_section_id,
            lot_incoming_save_section_name: selectLotData.lot_incoming_save_section_name,
            row_type:selectLotData.row_type,
            update_type: selectLotData.update_type,
          }
        )
      }
    }
  };

  const handleUserClick = (object) => {
    var doubleYN = 'N' 
    for(let i = 0; i < userRows.length; i++){
      if(userRows[i].incoming_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
        doubleYN = 'Y'
      }
    }
    if(doubleYN === 'Y'){
      Swal.fire({
        title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
        text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
        confirmButtonText: '확인'
      });
    } else {
      if(object.id !== selectUserData.user_id){
        processUserRowUpdate(
          {
            id : selectUserData.id,
            incoming_user_id: object.id,
            incoming_user_name: object.user_name,
            incoming_user_dept_name: object.dept_name,
            incoming_user_position_name: object.position_name,
            incoming_user_type: (selectUserData.incoming_user_type === 0 || selectUserData.incoming_user_type === '') ? 178 : selectUserData.incoming_user_type,
            incoming_user_bigo: selectUserData.incoming_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          },
          {
            id : selectUserData.id,
            incoming_user_id: selectUserData.incoming_user_id,
            incoming_user_name: selectUserData.incoming_user_name,
            incoming_user_type: (selectUserData.incoming_user_type === 0 || selectUserData.incoming_user_type === '') ? 178 : selectUserData.incoming_user_type,
            incoming_user_dept_name: selectUserData.incoming_user_dept_name,
            incoming_user_position_name: selectUserData.incoming_user_position_name,
            incoming_user_bigo: selectUserData.incoming_user_bigo,
            row_type: selectUserData.row_type,
            update_type: selectUserData.update_type
          }
        )
      }
    }
  };

  const handleSave = (event) => {
    let msg = '';

    if(inputs.incoming_partner_id === 0 || inputs.incoming_partner_id === ''){
      msg = '입고처는 필수 선택 입니다.'
    }else if((inputs.incoming_date) === '' || (inputs.incoming_date) < '2025-01-01' || (inputs.incoming_date).length != 10){
      msg = '입고일자 입력이 올바르지 않습니다.<br/>(입력 양식 : 2025-01-01 ~ )'
    }else if(inputs.incoming_partner_manager_phone.trim() !== '' && !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.incoming_partner_manager_phone.trim())){
      msg = '담당자 휴대번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 010-숫자3,4자리-숫자4자리)';
    }else if(inputs.incoming_partner_manager_mail.trim() !== '' && !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.incoming_partner_manager_mail.trim())){
      msg = '담당자 E-Mail 입력이 올바르지 않습니다.';
    }

    if(updateItemRows.length === 0){ 
      msg = '입고 품목이 존재하지 않습니다.';
    } else if(updateItemRows.length > 0 && msg === ''){ 
      for(let i = 0; i < updateItemRows.length; i++) {
        const incoming_item_id = updateItemRows[i].incoming_item_id;
        const incoming_package_count = updateItemRows[i].incoming_package_count;
        
        if(incoming_item_id === 0 || incoming_item_id === '') {
          msg = '선택되지 않는 입고 품목이 존재합니다.';
          break;
        }
        if(incoming_package_count === 0 || incoming_package_count === '' || incoming_package_count === null) {
          msg = '입력되지 않는 수량이 존재합니다.';
          break;
        }
        if(incoming_package_count < 0) {
          msg = '수량은 음수가 될 수 없습니다.';
          break;
        }
      }
    }

    if(updateUserRows.length > 0 && msg === ''){
      for(let i = 0; i < updateUserRows.length; i++) {
        const incoming_user_id = updateUserRows[i].incoming_user_id;
        const incoming_user_type = updateUserRows[i].incoming_user_type;
        
        if(incoming_user_id === 0 || incoming_user_id === '') {
          msg = '선택되지 않는 담당자명이 존재합니다.';
          break;
        }
        if(incoming_user_type === 0 || incoming_user_type === '') {
          msg = '선택되지 않는 담당자유형이 존재합니다.';
          break;
        }
      }
    }
    
    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">입고 등록 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);
      
      axios.post("/api/p/Incoming/Reg", {inputs, updateItemRows, updateUserRows, updateLotRows} ,
      { withCredentials: true })
      .then(function (response) {
        if(response.status === 200){

          var selectID = response.data;
          if(updateFileRows.length > 0) {

            const formData = new FormData();
            formData.append('selectID', selectID);
            formData.append('folder', 'Incoming');
            formData.append('type', 'Reg');
            formData.append('updateFileRows', JSON.stringify(updateFileRows));
            
            for(var i=0; i<realFiles.length; i++){            
              formData.append('files', realFiles[i]);
            }
            
            axios.post('/api/SaveCommon/GridFileSave'
                , formData
                , { headers: { 'Content-Type': 'multipart/form-data' } 
            }).then(response => {
              realFiles = []; tmpRealFiles = [];
              handleRegSuccessSave(selectID);
            }).catch(error => {
              appStore.capture();
            });

          }else{
            handleRegSuccessSave(selectID);
          }

        }else{
          appStore.capture();
        }
      })
      .catch(function (error) {
        appStore.capture();
      })
      .finally(() => {
        appStore.setLoading(false); 
      });

    }
  };
  
  const fRow = { display: 'flex', gap: '30px' };
  const fCell = { display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 };
  const fLabel = { width: '120px', flexShrink: 0, fontWeight: 'bold', fontSize: '15px', color: '#333', whiteSpace: 'nowrap' };
  const fInput = { flex: 1, minWidth: 0, height: '40px', border: '1px solid #ccc', borderRadius: '4px', padding: '0 12px', fontSize: '15px', boxSizing: 'border-box' };

  return (
    <TabContext value={tabID}>
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: '#fff', overflow: 'hidden' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fafafa', minHeight: '50px', paddingRight: '20px' }}>
          <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="정보" value="1" />
                <Tab label="품목" value="2" />
                <Tab label="Lot" value="3" />
                <Tab label="담당자" value="4" />
                <Tab label="파일" value="5" />
          </TabList>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    
                      <Button 
                        onClick={ handlePurchaseRef }
                        className="btn-p btn-u"
                        
                        sx={{  
                            m: 0.5, 
                            fontSize: 14, 
                            color: "white", 
                            borderColor: "#0067a3", 
                            backgroundColor: "#0067a3",
                            ":hover": { boxShadow: "2px 2px 2px #0067a3" , backgroundColor: "#0067a3", borderColor: "#0067a3"}
                        }} 
                        variant="outlined">
                        발주조회
                      </Button>
                    
                    
                      <Button 
                        onClick={ handleIncomingRef }
                        className="btn-p btn-u"
                        
                        sx={{  
                            m: 0.5, 
                            fontSize: 14, 
                            color: "white", 
                            borderColor: "rgb(62, 152, 243)", 
                            backgroundColor: "rgb(62, 152, 243)",
                            ":hover": { boxShadow: "2px 2px 2px rgb(62, 152, 243)" , backgroundColor: "rgb(62, 152, 243)", borderColor: "rgb(62, 152, 243)"}
                        }} 
                        variant="outlined">
                        입고조회
                      </Button>
                    
                    
                      {MenuUpdateYN === 'Y' &&
                      <Button 
                        onClick={handleSave}
                        className="btn-p btn-u"
                        sx={{  
                            m: 0.5, 
                            fontSize: 14, 
                            color: "white", 
                            borderColor: "#FF3636", 
                            backgroundColor: "#FF3636",
                            ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                        }} 
                        variant="outlined">
                        등록
                      </Button> }
                    
                  </div>
        </Box>
        <div ref={tabPanelRef} style={{ flex: 1, overflow: 'hidden', backgroundColor: '#fff', minHeight: 0 }}>
          <TabPanel value="1" style={{ height: '100%', overflow: 'auto', padding: 0 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '28px 34px', boxSizing: 'border-box', width: '100%' }}><div style={fRow}><div style={fCell}><label style={fLabel}>입고번호</label><input type="text" placeholder="입고번호" value={inputs.incoming_number} name="incoming_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true} style={{ ...fInput, fontWeight: 'bold', color: 'black', backgroundColor: '#f5f5f5' }} /></div><div style={fCell}><label style={fLabel}>발주번호</label><input type="text" placeholder="발주번호" value={inputs.incoming_purchase_number} name="incoming_purchase_number" onChange={(e) => onChange(e) } autoComplete="off" disabled={true} style={{ ...fInput, fontWeight: 'bold', color: 'black', backgroundColor: '#f5f5f5' }} /></div></div><div style={fRow}><div style={fCell}><label style={fLabel}>입고일자 <span style={{ color: 'red' }}>*</span></label><input type="date" value={inputs.incoming_date} name="incoming_date" onChange={(e) => onDateChange(e) } autoComplete="off" style={fInput} readOnly /></div><div style={fCell}><label style={fLabel}>입고처 <span style={{ color: 'red' }}>*</span></label><input type="text" placeholder="입고처" value={inputs.incoming_partner_name} name="incoming_partner_name" onChange={(e) => onChange(e) } onClick={(e) => onClick(e) } autoComplete="off" style={{ ...fInput, backgroundColor: '#EFEFEF4D', cursor: 'pointer' }} readOnly /></div></div><div style={{ display: 'flex', alignItems: 'center' }}><label style={fLabel}>입고처 담당자</label><div style={{ display: 'flex', flex: 1, minWidth: 0, gap: '12px' }}><input type="text" placeholder="이름" value={inputs.incoming_partner_manager} name="incoming_partner_manager" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, flex: 1 }} /><input type="text" placeholder="휴대폰번호" value={inputs.incoming_partner_manager_phone} name="incoming_partner_manager_phone" onChange={(e) => onHypenChange(e) } autoComplete="off" style={{ ...fInput, flex: 2 }} /><input type="text" placeholder="메일주소" value={inputs.incoming_partner_manager_mail} name="incoming_partner_manager_mail" onChange={(e) => onChange(e) } autoComplete="off" style={{ ...fInput, flex: 2 }} /></div></div><div style={{ display: 'flex', alignItems: 'flex-start' }}><label style={{ ...fLabel, marginTop: '10px' }}>비고</label><textarea placeholder="비고" name="incoming_bigo" value={inputs.incoming_bigo} onChange={(e) => onChange(e) } style={{ flex: 1, minWidth: 0, height: '110px', border: '1px solid #ccc', borderRadius: '4px', padding: '10px 12px', fontSize: '15px', resize: 'none', boxSizing: 'border-box' }} autoComplete="off"></textarea></div></div>
            </TabPanel>
            <TabPanel value="2" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={itemRows}
                  columns={itemColumns}
                  columnVisibilityModel={itemColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processItemRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="3" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={lotRows}
                  columns={lotColumns}
                  columnVisibilityModel={lotColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processLotRowUpdate}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="4" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  apiRef={apiRef}
                  rows={userRows}
                  columns={userColumns}
                  columnVisibilityModel={userColumnVisibilityModel}
                  editMode='cell'  
                  processRowUpdate={processUserRowUpdate}        
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  onCellClick={handleOnCellClick}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
            <TabPanel value="5" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={fileRows}
                  columns={fileColumns}
                  columnVisibilityModel={fileColumnVisibilityModel}
                  editMode='cell'       
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </div>
        </div>
        {isSelectPurchaseModalOpen && (<PurchaseSelectModal
          onClose={() => {
              setSelectPurchaseModalOpen(false);
          }}
          title={selectmodalTitle}
          openType={'Incoming'}
          handlePurchaseClick={handlePurchaseClick}
          />)}
        {isSelectIncomingModalOpen && (<IncomingSelectModal
          onClose={() => {
              setSelectIncomingModalOpen(false);
          }}
          title={selectmodalTitle}
          handleIncomingClick={handleIncomingClick}
          />)}
        {isSelectPartnerModalOpen && (<PartnerUserSelectModal
          onClose={() => {
              setSelectPartnerModalOpen(false);
          }}
          title={selectmodalTitle}
          handlePartnerUserClick={handlePartnerUserClick}
          />)}

        {isSelectItemModalOpen && (<ItemSelectModal hideDimensions={true}
          onClose={() => {
              setSelectItemModalOpen(false);
          }}
          title={selectmodalTitle}
          handleInputItemClick={handleInputItemClick}
          />)}

        {isSelectWorkplaceModalOpen && (<WorkplaceSelectModal
          onClose={() => {
              setSelectWorkplaceModalOpen(false);
          }}
          title={selectmodalTitle}
          handleWorkplaceClick={handleWorkplaceClick}
          />)}

        {isSelectWarehouseModalOpen && (<WarehouseSelectModal
            onClose={() => {
                setSelectWarehouseModalOpen(false);
            }}
            title={selectmodalTitle}
            upperWorkplaceId={upperWorkplaceId}
            handleWarehouseClick={handleWarehouseClick}
            />)}

        {isSelectWarehouseSectionModalOpen && (<WarehouseSectionSelectModal
            onClose={() => {
                setSelectWarehouseSectionModalOpen(false);
            }}
            title={selectmodalTitle}
            upperWarehouseId={upperWarehouseId}
            handleWarehouseSectionClick={handleWarehouseSectionClick}
            />)}

        {isSelectUserModalOpen && (<UserSelectModal
          onClose={() => {
              setSelectUserModalOpen(false);
          }}
          title={selectmodalTitle}
          handleUserClick={handleUserClick}
          />)}
    </TabContext>
  );
}

export default TAB_IncomingReg;